// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from '../duck';
import PunchCard from '../components/PunchCard';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    count: state.punchCard.count,
    total: state.punchCard.total,
    isFetchingPoints: state.punchCard.isFetchingPoints,
    isClaimingPoints: state.punchCard.isClaimingPoints,
    claimPointsError: state.punchCard.claimPointsError,
    locale: state.locale,
    coupon: state.punchCard.coupon,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...actions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PunchCard);



// WEBPACK FOOTER //
// ./src/modules/punch-card/containers/PunchCardContainer.jsx